type EqFunc<T> = (item1: T, item2: T) => boolean

/**
 * Returns an array with an intersection of the provided arrays.
 * Only elements that are present in every array are returned.
 *
 * The optional `eqFunc` argument should be provided when working with
 * arrays of objects rather than primitive types
 */
export const getIntersection = <T>(arrs: T[][], eqFunc: EqFunc<T> = (x, x2) => x === x2) => {
    const allItems = arrs.flat().filter((x, i, arr) => arr.findIndex((x2) => eqFunc(x, x2)) === i)
    return allItems.filter((x) => arrs.every((arr) => arr.find((x2) => eqFunc(x, x2))))
}
